export default __webpack_public_path__ + "static/step-1-7151b8ffd0cc8f9ae571b771713e3ed9.gif";